import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ImageZoom from "js-image-zoom";
import MetaComponent from "../../components/MetaComponent";
import { useParams } from "react-router-dom";
import { useNavigate, useHref } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Tooltip from '@mui/material/Tooltip';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';
import dayjs from 'dayjs'

import CartItemComponent from "../../components/CartItemComponent";

const config = require("../../constants/constants.js")
const { strCurrency, strEuroCurrency } = require('../../utils/currencyUtils.js')

const CartPageComponent = ({
  addToCart,
  removeFromCart,
  cartItems,
  cartSubtotal,
  reduxDispatch,
}) => {

  const { userInfo } = useSelector((state) => state.userRegisterLogin);
  const [isLoggato, setIsLoggato] = useState(false);

  function checkIsLoggato() {
    if (!userInfo || !userInfo.name) {
      console.log('[isLoggato] non loggato userInfo =', userInfo);
      setIsLoggato(false);
    } else {
      console.log('[isLoggato] loggato userInfo =', userInfo);
      setIsLoggato(true);
    }
  }

  const changeCount = (productID, count) => {
    reduxDispatch(addToCart(productID, count));
  };

  const removeFromCartHandler = (productID, quantity, price) => {
    if (window.confirm("Sei sicuro?")) {
      reduxDispatch(removeFromCart(productID, quantity, price));
    }
  }

  let navigate = useNavigate();

  const totaleItems = function (items) {
    let nrItems = 0;
    items.forEach(function (item, idx) {
      console.log(' item =', item)
      nrItems = nrItems + parseInt(item.quantity);

    })
    return nrItems === 1 ? nrItems + " prodotto" : nrItems + " prodotti"
  }

  useEffect(() => {
    setIsLoggato(checkIsLoggato)
  }, [isLoggato]);

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Breadcrumbs separator="›" aria-label="breadcrumb"
        size={{ xs: 12, md: 4 }}
        paddingTop={{ xs: 3, md: 3 }}
        paddingLeft={{ xs: 2, md: 6 }}
        paddingRight={{ xs: 1, md: 8 }}
        spacing={{ xs: 2, md: 2 }}
      >
        <Link underline="hover" color="inherit" href="/">
          {config.BC_HOME}
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/prodotti"
        >
          {config.BC_CARRELLO}
        </Link>
      </Breadcrumbs>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

      <Grid container spacing={0}>

        {/* 
       */}
        <Grid
          size={{ xs: 1, md: 1 }}
          padding={{ xs: 0, md: 0 }}
        >
        </Grid>

        <Grid
          size={{ xs: 12, md: 7 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 0, md: 0 }}
        >

          {cartItems.length === 0 ? (
            <Alert variant="info">Il tuo carrello è vuoto</Alert>
          ) : (
            <Box >
              {cartItems.map((item, idx) => (
                <CartItemComponent
                  item={item}
                  key={idx}
                  changeCount={changeCount}
                  removeFromCartHandler={removeFromCartHandler}
                />
              ))}
            </Box>
          )}

        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 1, paddingLeft: 2, paddingRight: 0,
              background: '#cce0e6',
              background: '#bfdae3ff',
            }}
            elevation={6}
          >

            <Box
              sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
              noValidate
              autoComplete="off"
            >

              <Typography variant="body2"
                sx={{
                  color: 'text.secondary',
                  paddingTop: 0,
                  paddingBottom: 1,
                  fontFamily: 'Arial',
                  fontWeight: 700,
                  fontSize: 30,
                  color: 'text.primary',

                }}
              >
                Carrello
              </Typography>

              <TextField id="id-nrprodotti" label="nr prodotti" variant="outlined" value={totaleItems(cartItems)}
                size="small"
                slotProps={{
                  input: { readOnly: true },
                  inputLabel: { shrink: true }
                }}
                onChange={(event) => {
                  //setName(event.target.value);
                }}
              />

              <TextField id="id-totale" label="totale" variant="outlined" value={strEuroCurrency(cartSubtotal)}
                size="small"
                slotProps={{
                  input: { readOnly: true },
                  inputLabel: { shrink: true }
                }}
                onChange={(event) => {
                  //setName(event.target.value);
                }}
              />

              <Box display={isLoggato ? "block" : "none"} >
                <Button
                  type="button"
                  variant="contained"
                  color="success"
                  hidden="true"
                  //size="small"
                  disabled={cartSubtotal === 0}
                  onClick={(e) => {
                    navigate("/user/cart-details")
                  }}
                  sx={{
                    width: "20ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                >
                  Procedi al Checkout
                </Button>

              </Box>

              <Box display={!isLoggato ? "block" : "none"} >

                <Button
                  type="button"
                  variant="contained"
                  color="success"
                  //size="small"
                  disabled={cartSubtotal === 0}
                  onClick={(e) => {
                    navigate("/login")
                    //window.location.assign('/login')
                  }}
                  sx={{
                    width: "20ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                >
                  Procedi al login
                </Button>
              </Box>

            </Box>

          </Paper>


        </Grid>


      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

    </Box>


  );
};

export default CartPageComponent;
